export const maxWidth = 1184;
